import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Box, Container, Typography } from '@mui/material';
import { useEffect } from 'react';
import Navbar from './Navbar';
import Contact from './Contact';
import Footer from './Footer';
import ProductsHeader from './Products/ProductsHeader';
import ProductCard from './Products/ProductCard';
import { PYTHOGRASS_PRODUCTS } from './Products/productData';
import './CSS/AboutPage.css';

const PAGE_TITLE = 'Pythograss Collection | ZJ Associates';
const PAGE_DESCRIPTION =
  'Explore the Pythograss Collection by ZJ Associates - premium grass and landscaping solutions for residential and commercial projects.';

const theme = createTheme({
  palette: {
    primary: { main: '#ffffff' },
    secondary: { main: '#C5A47E' },
  },
  typography: { fontFamily: 'Barlow' },
});

export const PythograssCollectionPage = () => {
  useEffect(() => {
    document.title = PAGE_TITLE;
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) metaDescription.setAttribute('content', PAGE_DESCRIPTION);
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = window.location.origin + '/products/pythograss-collection';
    return () => {
      document.title = 'ZJ Associates';
    };
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Navbar />
      <ProductsHeader title="Pythograss Collection" subtitle="PRODUCTS" />
      <main id="main-content" role="main" aria-label="Pythograss Collection content">
        <Container component="section" maxWidth="lg" sx={{ py: 6 }}>
          <Box sx={{ maxWidth: '800px', mx: 'auto', mb: 4 }}>
            <Typography component="h2" variant="h4" fontWeight="600" color="secondary" gutterBottom>
              Pythograss Collection
            </Typography>
            <Typography component="p" variant="body1" color="primary" paragraph>
              The Pythograss Collection offers premium grass and landscaping solutions for residential and commercial projects.
              Designed to complement our architectural and construction services, this product line brings quality and durability
              to outdoor spaces.
            </Typography>
          </Box>
          <Box
            component="ul"
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 3,
              listStyle: 'none',
              m: 0,
              p: 0,
            }}
          >
            {PYTHOGRASS_PRODUCTS.map((product) => (
              <Box component="li" key={product.id}>
                <ProductCard
                  images={product.images}
                  title={product.title}
                  description={product.description}
                  options={product.options}
                  dimensions={product.dimensions}
                />
              </Box>
            ))}
          </Box>
        </Container>
      </main>
      <Contact />
      <Footer />
    </ThemeProvider>
  );
};
